import * as React from 'react';
import { Button } from 'antd';
import { HeartFilled } from '@ant-design/icons';
import Config from '../VisualMemory/engine/Config';
import Tile from '../VisualMemory/engine/Tile';
import SequenceMemoryEngine from './engine/SequenceMemoryEngine';
import { displayTime } from '../functions';
import { saveUserRecord } from '../api';
import gamesList from '../../components/components/ChooseGame/gamesList';
import UserContext from '../../contexts/UserContext';
import ShowTime from '../../components/components/ShowTime/ShowTime';
import { VisualMemoryBox, GameBoard, TileBox, InfoBarBox, LivesBox, LevelBox, BoardBox, HeartBox, LevelAnimation, GameOverAnimation, GameOverInfoBox, GameOverRow, GameOverButton, levelAnimationTime, tileAnimationTime } from './SequenceMemory.css';

const vm = new SequenceMemoryEngine();

const SequenceMemory = (): JSX.Element => {
    const { useEffect, useState, useContext } = React;
    const {user, setUser} = useContext(UserContext);
    const [loading, setLoading] = useState(true);
    const [levelAnimation, setLevelAnimation] = useState(false);
    const [gameOver, setGameOver] = useState(false);
    const [nextLevel, setNextLevel] = useState(1);
    const [tiles, setTiles] = useState<Tile[]>([]);
    const [gameConfig, setGameConfig] = useState<Config>(new Config());
    const [gameStarted, setGameStarted] = useState(false);
    const [sequence, setSequence] = useState<number[]>([]);
    const [sequenceCorrect, setSequenceCorrect] = useState<boolean[]>([]);
    const [startTime, setStartTime] = useState(0);
    const [gameTime, setGameTime] = useState(0);
    const [scoreSaved, setScoreSaved] = useState(false);

    useEffect(() => {
        start();
    }, []);

    const start = (autostart?: boolean) => {
        vm.config.level = 1;
        vm.config.lives = 1 ;
        vm.sequence = [];
        vm.config.width = 3;
        vm.config.height = 3;
        vm.initGame();
        setGameOver(false);
        setSequenceCorrect([]);
        setSequence(vm.sequence);
        setGameConfig(vm.config);
        setTiles(vm.tiles);
        if (autostart) {
            showTypedTiles(vm.tiles, vm.sequence);
        }
    };

    const remakeGame = () => {
        start(true);
    }

    const showTile = (index: number, _tiles: Tile[]) => {
        const oldTiles = _tiles ? _tiles : tiles;
        return new Promise((resolve, reject) => {
            const newTiles = [...oldTiles];
            // newTiles[index].rotate = true;
            newTiles[index].highlight = true;
            newTiles[index].typed = true;
            setTiles(newTiles);
            setTimeout(() => {
                const newTiles2 = [...oldTiles];
                // newTiles2[index].rotate = false;
                newTiles2[index].highlight = false;
                newTiles[index].typed = false;
                newTiles[index].hidden = true;
                setTiles(newTiles2);
                resolve(true);
            }, 700);
        })
    }

    const showTypedTiles = async (_tiles?: Tile[], _seq?: number[]) => {
        const oldTiles = _tiles ? _tiles : tiles;
        const seq = _seq ? _seq : sequence;
        for (let i = 0; i < seq.length; i++) {
            console.log('showing ' + seq[i].toString());
            await showTile(seq[i], oldTiles);
        }
        setTiles(oldTiles);
        setLevelAnimation(false);
        setLoading(false);
        // const oldTiles = _tiles ? _tiles : tiles;
        // const newTiles = [...oldTiles.map(x => {
        //     if (x.typed) {
        //         return {...x, highlight: true, rotate: true};
        //     }
        //     return x;
        // })];
        // setTiles(newTiles);
        // setTimeout(() => {
        //     setTiles(oldTiles);
        //     setLevelAnimation(false);
        //     setLoading(false);
        // }, 2000)
    };

    const handleClickTile = (tileNum: number) => {
        if (loading) return;
        const newTiles = [...tiles.map( x => { return {...x, hidden: true}})];
        newTiles[tileNum].hidden = false;
        // newTiles[tileNum].rotate = true;
        const index = sequenceCorrect.length;
        if (sequence[index] === tileNum) {
            sequenceCorrect.push(true);
            newTiles[tileNum].typed = true;
        } else {
            newTiles[tileNum].typed = false;
            // game over
            if (gameConfig.lives === 1) {
                // setGameTime(Date.now() - startTime);
                setGameOver(true);
                setGameConfig({...gameConfig, lives: 0});
                return;
            }
            setLoading(true);
            console.log(vm.tiles);
            // setTiles([...vm.tiles.map( x => { return {...x, hidden: true}})]);
            setTimeout(() => {
                newLevel(gameConfig.level, gameConfig.lives - 1, true);
            }, 300);
            return;
        }
        setTiles(newTiles);

        if (sequence.length === sequenceCorrect.length)  {
            setLoading(true);
            setNextLevel(gameConfig.level + 1);
            setLevelAnimation(true);
            setTiles([...tiles.map( x => { return {...x, hidden: true}})]);
            setTimeout(() => {
                newLevel();
            }, levelAnimationTime + tileAnimationTime);
        }

        // sprawdz może to już gameover
        // const countNotCorrect = newTiles.filter(x => x.hidden === false && x.typed === false).length;
        // if (countNotCorrect > 2) {
        //     if (gameConfig.lives === 1) {
        //         setGameOver(true);
        //         setGameConfig({...gameConfig, lives: 0});
        //         return;
        //     }
        //     setLoading(true);
        //     setTimeout(() => {
        //         newLevel(gameConfig.level, gameConfig.lives - 1);
        //     }, 300);
        //     return;
        // }
        // const countCorrect = newTiles.filter(x => x.hidden === false && x.typed === true).length;
        // if (countCorrect >= gameConfig.memoryCount) {
        //     setLoading(true);
        //     setNextLevel(gameConfig.level + 1);
        //     setLevelAnimation(true);
        //     setTimeout(() => {
        //         newLevel();
        //     }, 300);
        // }
    };

    // const sleep = (time: number): Promise<void> => new Promise(r => setTimeout(r, time));

    const newLevel = (level?: number, lives?: number, remake?: boolean) => {
        setLoading(true);
        setSequenceCorrect([]);
        if (level) {
            vm.config.level = level;
        } else {
            vm.config.level++;
        }
        if (lives) {
            vm.config.lives = lives;
        }
        vm.initGame(remake);
        setGameTime(Date.now() - startTime);
        setGameConfig(vm.config);
        setSequence(vm.sequence);
        setTiles(vm.tiles);
        showTypedTiles(vm.tiles);
    }

    const handleStartGame = () => {
        setStartTime(Date.now());
        showTypedTiles();
        setGameStarted(true);
    };

    const renderLives = () => {
        const tlives = [];
        for (let i = 0; i < gameConfig.lives; i++) {
            tlives.push(1)
        }
        return <HeartBox>
            {tlives.length > 0 && tlives.map( x => <HeartFilled />)}
        </HeartBox>
    };

    const saveScore = async () => {
        const gameId = gamesList.find(x => x.id === 'sm')?.gameId || 0;
        const saved = await saveUserRecord(user.id, nextLevel, gameTime, gameId);
        setScoreSaved(true);
        console.log(saved);
    };


    return (
        <VisualMemoryBox>
            {levelAnimation && <LevelAnimation>LEVEL {nextLevel}</LevelAnimation>}
            {gameOver && <GameOverAnimation>
                <GameOverInfoBox>
                    <GameOverRow>
                        LEVEL {gameConfig.level}
                    </GameOverRow>
                    <GameOverRow>
                        <ShowTime time={displayTime(gameTime)} />
                    </GameOverRow>
                    <GameOverButton>
                        <Button onClick={remakeGame}>PLAY AGAIN</Button>
                        {nextLevel > 1 && <Button style={{marginLeft: 5}} disabled={scoreSaved} onClick={saveScore}>{scoreSaved ? 'SAVED' : 'SAVE SCORE'}</Button>}
                    </GameOverButton>
                </GameOverInfoBox>
            </GameOverAnimation>}
            {gameStarted ? <BoardBox>
                <InfoBarBox>
                    <LevelBox>
                        LEVEL {gameConfig.level}
                    </LevelBox>
                    { // gameTime === 0 && <Timer interval={100} timeStart={startTime} />
                    }
                    <LivesBox>
                        {renderLives()}
                    </LivesBox>
                </InfoBarBox>
                <GameBoard columns={gameConfig.width}>
                    {tiles.map((tile: Tile, tileNum: number) =>
                        <TileBox highlight={tile.highlight} typed={tile.typed} rotated={tile.rotate} hidd={tile.hidden} key={tileNum} onClick={() => handleClickTile(tileNum)}></TileBox>
                    )}
                </GameBoard>
            </BoardBox> :
            <Button onClick={handleStartGame}>START</Button>}
        </VisualMemoryBox>
    );
};

export default SequenceMemory;